module.exports = __webpack_public_path__ + "static/bis-2024-951872fb179bc5d7a87581f984cacd0d.jpg";